export const msgs = {
  accessDenied: 'Accesso negato',
  accountNotExist: 'Questo account non esiste',
  addingAMarketer: 'Aggiungere un responsabile marketing è obbligatorio per poter modificare in futuro il marketing',
  addingAMinter: 'Aggiungere un minter è obbligatorio per poter eseguire il mint di ulteriori token',
  amonutLessThanBalance: 'L\'importo deve essere inferiore al saldo',
  amountGreaterZero: 'L\'importo deve essere maggiore od uguale a zero',
  amountVsCap: 'Se c\'è un cap, l\'importo deve essere minore o uguale al cap',
  assertAndShowHash: 'La transazione è stata eseguita con successo e l\'hash è:',
  assertAndViewTx: 'La transazione è stata eseguita con successo e può essere visualizzata a questo link',
  bannerPrimary: 'Commercio.network: The Digital Transformation Blockchain',
  bannerSecondary: 'Creare un ID, firmare e scambiare documenti sulla prima Blockchain conforme eIDAS in Europa',
  comingSoon: 'Prossimamente',
  connected: 'connesso',
  copy: 'Copia',
  cw20SymbolPolicies: 'Il simbolo deve essere di min 3 caratteri e max 12, e può contenere solo lettere maiuscole e minuscole ed il trattino',
  dataNotAvailable: 'In questo momento i dati, purtroppo, non sono disponibili. Si prega di aggiornare la pagina.',
  decimalField: 'Questo campo accetta solo numeri decimali',
  delegateAdvice1: 'Lo staking bloccherà i fondi per {duration}.',
  delegateAdvice2: 'Dovrai ritirare la delega per rendere nuovamente liquidi i tuoi staked assets.',
  delegateAdvice3: 'Il processo richiederà {duration} per essere completato.',
  dropYourFile: 'Trascina qui il file, oppure fai clic per selezionarlo.',
  estimatedTime: 'Tempo stimato',
  exchangeRateCalc: '1 diviso la % di Supply circolante',
  failed: 'Fallito',
  failedToDetectTheChain: 'Impossibile identificare la chain',
  failedToSuggestTheChain: 'Impossibile suggerire la chain',
  filesCorrespond: 'L\'impronta del file (Hash) inviato corrisponde alla notarizzazione nella blockchain.',
  filesNotCorrespond: 'L\'impronta del file (Hash) inviato NON corrisponde alla notarizzazione nella blockchain. Controlla che il file che inviato sia quello corretto.',
  filterByStatus: 'Filtra per stato',
  filterValidatorsInfo: 'Filtra la lista per stato',
  installKeplrExtension: 'Si prega di installare l\'estensione Keplr',
  listPrice : 'Prezzo di listino',
  loading: 'Caricando...',
  lostBlocks: 'Perso {0} su 20K',
  mandatoryField: 'Questo campo è obbligatorio',
  noAccountFound: 'Nessun conto trovato. Utilizza l\'estensione Keplr per crearlo o importarlo.',
  noCode: 'Codice non disponibile',
  noMessage: 'Messaggio non disponibile',
  noWalletConnected: 'Nessun wallet connesso',
  notAvailable: 'Non disponibile',
  notFound: 'Non trovato',
  placeholderSearchBar: 'Cerca indirizzo, blocco, transazione',
  positiveAmount: 'L\'importo deve essere positivo',
  scan: 'Scansiona',
  scanAddress: 'Scansiona indirizzo',
  searchBlocksInfo: 'Cerca {0} blocchi in ordine discendente da un\'altezza (min {1})',
  searchValidatorsInfo: 'Cerca validatore per nome, indirizzo e account collegato',
  startTypingToFilterTypes: 'Inizia a digitare per filtrare i tipi',
  success: 'Successo',
  tooLongField: 'Questo campo è troppo lungo',
  triggeredAnError: 'È successo qualcosa nell\'impostazione della richiesta che ha generato un errore',
  unansweredRequest: 'La richiesta è stata fatta ma non è stata ricevuta alcuna risposta',
  undelegateAdvice: 'Una volta ritirata la delega non si riceveranno più gli staking rewards e non si potrà più annullare il ritiro della delega; bisognerà attendere {duration} perché l\'importo venga liquidato.',
  underMaintenance: 'Ci stiamo lavorando, torna più tardi!',
  unsupportedAlgorithm: 'L\'algoritmo non è supportato',
  validatorNotExist: 'Questo validatore non esiste',
  verificationFailed: 'Male!!!  Verifica fallita.',
  verificationSuccess: 'Ottimo!!! Verifica riuscita.',
  waitingForChainInfo: 'Caricamento configurazione chain...',
  chainConfigurationError: 'Impossibile caricare la configurazione della chain. Riprova.',
  workInProgress: 'Lavori in corso',
  youVoted: 'Hai votato "{0}"',
};
